
/*=======================================================================================
NOTE: Auto Generated File
=========================================================================================
Date:       2021-06-18 17:26:07.490
From:       BADGER\SQL2016 - qmuzik_metabase
Comment:    Any manual changes to this file will be overwritten. Move it to the relevant 
			"Custom" directory of the Angular project should you need to maintain your
			own version.
=========================================================================================*/

import { Observable } from 'rxjs';

import { AppInjector, AppGlobal } from "qmuzik-angular-model-core";
import { EISTaskSecurity } from "qmuzik-angular-model";
import { EISTaskSecurityModelStateValidation } from '../../modelstate-validation/generated/eistasksecurity-modelstate.validate';
import { ViewStateValidationBase } from 'qmuzik-angular-base';
import { ViewStateValidation } from 'qmuzik-angular-model-core'

import * as ts from "typescript";
import { Rules, Rule, SystemHooks } from "qmuzik-angular-model-core";
import { ColumnValuesService, InitialisationService, UtilityService } from 'qmuzik-angular-service';
import { DataContextService } from 'qmuzik-angular-service';
import { NotificationService } from 'qmuzik-angular-service';
import { Injectable } from '@angular/core';
import * as compiledRules from '../../rules/generated/eistasksecurity.rule';

//validate and apply any rules that will affect the
//display of the view e.g. colors, enabled, disabled, visible, hidden etc.
@Injectable()
export class EISTaskSecurityViewStateValidation extends ViewStateValidationBase implements ViewStateValidation{
    public utilityService: UtilityService;

    constructor(
        columnValuesService: ColumnValuesService,
        dataContextService: DataContextService,
        notificationService: NotificationService,
        initialisationService: InitialisationService,
        appGlobal: AppGlobal) 
    { 
        super(
            columnValuesService,
            dataContextService,
            notificationService,
            initialisationService,
            appGlobal
        ); 
        
        this.modelStateType = EISTaskSecurity;
		this.modelStateTypeName = "EISTaskSecurity";
        this.viewStateValidatorName = "EISTaskSecurity";

        //note: to make services available to the validator we must inject it (constructor does not work, maybe because it is never used it is never injected)
		//		keep this example below, so that you know how you will gain access to any service from within your rule scripts e.g. validator.utilityService...
        //this.utilityService = AppInjector.get(UtilityService);
    }

    //note: get transpiled rules, if we are in production build
	//		this is called from the base class in production build
	//		you can import and add your own additional transpiled rules here
    GetRules(){
		this.rules = compiledRules.BuildRules(false, true);
    }       
}

